import { ViaLyberaNavigation } from '@bilancio/api';
import { InterFrameBilMsg, InterFrameCmd } from '../interframe-global.model';

export type VlMessage = `${InterFrameCmd}vl-${string}`;

export type ViaLyberaMsgOneReq = InterFrameBilMsg<'interframe-vl-msg-one'>;
export type ViaLyberaMsgTwoReq = InterFrameBilMsg<
    'interframe-vl-msg-two',
    { id: number }
>;
export type ViaLyberaMsgThreeReq = InterFrameBilMsg<
    'interframe-vl-msg-three',
    { name: string }
>;
export type ViaLyberaMsgFourReq = InterFrameBilMsg<
    'interframe-vl-msg-four',
    { startDate: Date }
>;
export type ViaLyberaMsgLoginReq = InterFrameBilMsg<
    'interframe-vl-login',
    {
        sessionId: string;
        tsProcId: string;
        navigation: ViaLyberaNavigation;
        tsClientName: string;
    }
>;

export type ViaLyberaMsgLogoutReq = InterFrameBilMsg<'interframe-vl-logout'>;

export type ViaLyberaMsgReqUnion =
    | ViaLyberaMsgOneReq
    | ViaLyberaMsgTwoReq
    | ViaLyberaMsgThreeReq
    | ViaLyberaMsgFourReq
    | ViaLyberaMsgLoginReq
    | ViaLyberaMsgLogoutReq;

/**
 * Extract the message literal types from ViaLyberaMsgReqUnion
 * This type will be a union of all the possible message values
 */
type ViaLyberaMessageTypes = ViaLyberaMsgReqUnion['Command'];

/**
 * Type guard to check if a value is of type ViaLyberaMsgReqUnion
 * @param value The value to check (must be an InterFrameBilMsg<string>)
 * @returns True if the value is a valid ViaLyberaMsgReqUnion type, false otherwise
 */
export const isViaLyberaMessages = (
    value: InterFrameBilMsg<VlMessage>
): value is ViaLyberaMsgReqUnion => {
    // Type assertion to check if the message is one of the valid message types
    // This approach automatically works with any new messages added to ViaLyberaMsgReqUnion
    return isMessageType(value.Command);
};

/**
 * Helper type guard to check if a string is a valid MyBizMessageTypes
 * @param message The message string to check
 * @returns True if the message is a valid MyBizMessageTypes
 */
const isMessageType = (message: string): message is ViaLyberaMessageTypes => {
    // This is a type-safe way to check if a string is in the union type
    // TypeScript will ensure this stays in sync with MyBizMessageTypes
    switch (message) {
        case 'interframe-vl-msg-one':
        case 'interframe-vl-msg-two':
        case 'interframe-vl-msg-three':
        case 'interframe-vl-msg-four':
        case 'interframe-vl-login':
        case 'interframe-vl-logout':
            return true;
        default:
            return false;
    }
};

export type ViaLyberaMsgTwoResp = InterFrameBilMsg<
    'interframe-vl-msg-two-resp',
    { status: string; receivedId: number }
>;
export type ViaLyberaMsgThreeResp = InterFrameBilMsg<
    'interframe-vl-msg-three-resp',
    { status: string; receivedName: string }
>;

export type ViaLyberaMsgLoginResp = InterFrameBilMsg<
    'interframe-vl-login',
    {
        sessionId: string;
        tsProcId: string;
        navigation: ViaLyberaNavigation;
        tsClientName: string;
    }
>;

export type ViaLyberaMsgRespUnion =
    | ViaLyberaMsgTwoResp
    | ViaLyberaMsgThreeResp
    | ViaLyberaMsgLoginResp;
